import React, { useState, useEffect } from "react";
import { Button, FormGroup, Row, Col, Label, Form, Modal, ModalHeader, ModalBody, ModalFooter, Input, Collapse } from 'reactstrap';
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import { AppsClient } from "services";
import { useXeroClient } from "hooks";
import { Trans } from "react-i18next";
import store_logo from '../../assets/images/integration-icon.svg';

const LineAmountTypes = [
    { value: 'Exclusive', label: 'Exclusive' },
    { value: 'Inclusive', label: 'Inclusive' },
    { value: 'NoTax', label: 'NoTax' }
]

export const ExSpan = ({ label, value }) => (
    <Col className="my-2" md={12}>
        <div><Trans>{label}</Trans></div><div className="text-muted">{value || "-"}</div>
    </Col>
  );

export const required_settings = [
    'COGSAccountCode',
    'InventoryAssetAccountCode',
    'TaxType',
    'AccountCode',
    'InventoryAdjustment',
    'OtherRevenueAccount',
    'ShippingLiability',
    'ShippingFees',
    'TrackingCategoryName',
]

export const DetailModal = ({ modal, toggle, app }) => {

    const yearlyPrice = app?.subscription_prices?.find(i => i.plan_type === "Yearly")?.price
    const monthlyPrice = app?.subscription_prices?.find(i => i.plan_type === "Monthly")?.price

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle}><Trans>Application Details</Trans></ModalHeader>
            <ModalBody>
                <div className="text-center">
                {app?.store?.avatar && 
                    <img
                        src={app?.store?.name ? (app.store.avatar ? app?.store?.avatar : store_logo ) : require(`../../assets/images/applications/${app?.store?.avatar}`).default}
                        className="m-auto"
                        alt=""
                        width={60}
                    />}
                </div>
                    <Row>
                        <ExSpan label="Application Name" value={app?.name}/>
                        <ExSpan label="Description" value={app?.description}/>
                        {monthlyPrice && <ExSpan label="Monthly Price" value={monthlyPrice}/>}
                        {yearlyPrice && <ExSpan label="Yearly Price" value={yearlyPrice}/>}
                    </Row>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}><Trans>Close</Trans></Button>
            </ModalFooter>
        </Modal>
    )
  }

const SettingsModal = ({ modal, toggle, id, t, setLoading }) => {
    const apps_client = AppsClient()
    const client = useXeroClient()

    const [settings, setSettings] = useState({});

    const [accounts, setAccounts] = useState([]);
    const [bankAccounts, setBankAccount] = useState([]);
    const [categories, setCategories] = useState([])
    const [advanced, setAdvanced] = useState(false)
    // ----------------------------------
    async function fetchData() {
        const response_accounts = await client.get('accounts', {
            params: {
                raw: `Status="ACTIVE"`,
            },
        },).get("data");


        const response_categories = await client.get('trackingcategories', {
            params: {
                raw: `Status="ACTIVE"`,
            },
        },).get("data");



        let bankAccounts = []
        let accounts = []

        for (var i = 0; i < response_accounts.length; i++) {
            // Iterate over numeric indexes from 0 to 5, as everyone expects.
            const el = response_accounts[i]
            if (el.Type === "BANK") {
                bankAccounts.push({
                    label: el.Name,
                    value: el.AccountID,
                })
            }
            else {
                accounts.push({
                    label: `${el.Name} (${el.Code})`,
                    value: el.Code,
                })
            }
        }

        let trackings = []
        for (var i = 0; i < response_categories.length; i++) {
            // Iterate over numeric indexes from 0 to 5, as everyone expects.
            const el = response_categories[i]
            trackings.push({
                label: el.Name,
                value: el.Name,
            })
        }



        setAccounts(accounts);

        setBankAccount(bankAccounts);

        setCategories(trackings)

    };


    const getAppSettings = (id) => {
        if (id !== null) {
            apps_client.get(`settings/${id}`).then((resp) => {
                setSettings(resp.data)
            })
        }
    }
    function validateSettings(settings) {
        for (const key in settings) {
            if (required_settings.includes(key) && (settings[key] === null || settings[key] === undefined || settings[key] === "")) {
                NotificationManager.error(t("Can't Save, Fill in the required fields" + " " + key, {})  )
                return false
            }
        }
        return true
    }
    const HandleSubmit = () => {
        setLoading(true)
        if (!validateSettings(settings)) {
            setLoading(false)
            return
        }

        apps_client.put(`settings/${id}`, settings).then((resp) => {
            setSettings(resp.data)
            NotificationManager.success(
                t("Saved Successfully", {})
            )
            setLoading(false)
            toggle()
        }).catch((err) => {
            NotificationManager.error(
                t("Couldn't Save {err}", { err })
            )
            setLoading(false)
            toggle()
        })
    }
    // ----------------------------------

    useEffect(() => {
        fetchData();
        getAppSettings(id)
    }, [modal]);

    const AccountSelect = ({ label, field, options, required }) => (
        <FormGroup>
            <Col className="col">
                <Label>{label} {required && "*"}</Label>
                <FormGroup>
                    <Select placeholder={t('Select Account Code')} options={options || []} value={settings[field]} onChange={(e) => setSettings({ ...settings, [field]: e ? e.value : "" })} />
                </FormGroup>
            </Col>
        </FormGroup>
    );

    return (
        <Modal isOpen={modal} toggle={toggle} size="lg" >
            <ModalHeader toggle={toggle}><Trans>Edit Settings</Trans></ModalHeader>
            <ModalBody style={{ overflowY: 'visible' }}>
                <Form>
                    <Row>
                        <div className="col-12 mb-3">
                            <AccountSelect label={t("Cost Of Goods Sold Account")} field={'COGSAccountCode'} options={accounts} required/>
                        </div>
                        <div className="col-12 mb-3">
                            <AccountSelect label={t("Inventory Asset Account")} field={'InventoryAssetAccountCode'} options={accounts} required/>
                        </div>
                        <div className="col-12 mb-3">
                            <AccountSelect label={t("Tax Type")} field={'TaxType'} options={LineAmountTypes} required/>
                        </div>

                        <div className="col-12 mb-3">
                            <AccountSelect label={t("Sales Account")} field={'AccountCode'} options={accounts} required/>
                        </div>

                        <div className="col-12 mb-3">
                            <AccountSelect label={t("Inventory Adjustments Account")} field={'InventoryAdjustment'} options={accounts} required/>
                        </div>
                        <div className="col-12 mb-3">
                            <AccountSelect label={t("Other Revenue Account")} field={'OtherRevenueAccount'} options={accounts} required/>
                        </div>
                        <div className="col-12 mb-3">
                            <FormGroup check style={{ paddingInlineStart: '2.25rem' }}>
                                <Input name="ExternalShipping" type="checkbox" checked={settings.ExternalShipping} onChange={(e) => setSettings({ ...settings, ExternalShipping: !settings.ExternalShipping })} />
                                <Label check htmlFor="ExternalShipping"><Trans>External Shipping Company?</Trans></Label>
                            </FormGroup>
                        </div>
                        <div className="col-12 mb-3">
                            <AccountSelect label={t("Shipping Liability Account")} field={'ShippingLiability'} options={accounts} required/>
                        </div>
                        <div className="col-12 mb-3">
                            <FormGroup check style={{ paddingInlineStart: '2.25rem' }}>
                                <Input name="WePayShippingOnCancel" type="checkbox" checked={settings.WePayShippingOnCancel} onChange={(e) => setSettings({ ...settings, WePayShippingOnCancel: !settings.WePayShippingOnCancel })} />
                                <Label check htmlFor="WePayShippingOnCancel"><Trans>Company Handles Cancellation Shipping Fees?</Trans></Label>
                            </FormGroup>
                        </div>
                        <div className="col-12 mb-3">
                            <AccountSelect label={t("Shipping Cancellation Fees Account")} field={'ShippingFees'} options={accounts} />
                        </div>
                        <div className="col-12 mb-3">
                            <AccountSelect label={t("Tracking Category")} field={'TrackingCategoryName'} options={categories} required/>
                        </div>
                        <div className="col-12">
                            <button className="btn btn-link link text-success shadow-none" onClick={(e) => { e.preventDefault(); setAdvanced(!advanced) }}>
                                <i className="fas fa-chevron-down mx-0 px-0"></i> <Trans>POS Settings</Trans>
                            </button>
                        </div>
                        <Collapse isOpen={advanced} className="container-fluid col-12">
                            <div className="border">
                                <div className="col-12 mb-3 px-0">
                                    <AccountSelect label={t("Tips Account")} field={'TipsAccountCode'} options={accounts} />
                                </div>
                                <div className="col-12 mb-3 px-0">
                                    <AccountSelect label={t("Discount Account")} field={'DiscountAccountCode'} options={accounts} />
                                </div>
                                <div className="col-12 mb-3 px-0">
                                    <AccountSelect label={t("Rounding Account")} field={'RoundingAccountCode'} options={accounts} />
                                </div>
                            </div>
                            <div className="sub-title form-group mx-1 mt-2">
                                <Trans>Manual Journal Accounts</Trans>
                            </div>
                            <div className="border my-2">
                                <div className="col-12 mb-3 px-0">
                                    <AccountSelect label={t("Inventory Account")} field={'InventoryAccount'} options={accounts} />
                                </div>
                                <div className="col-12 mb-3 px-0">
                                    <AccountSelect label={t("Pending Transfer Account")} field={'PendingTransferAccount'} options={accounts} />
                                </div>
                                <div className="col-12 mb-3 px-0">
                                    <AccountSelect label={t("Adjustments Inventory Account")} field={'AdjustmentsInventoryAccount'} options={accounts} />
                                </div>
                                <div className="col-12 mb-3 px-0">
                                    <AccountSelect label={t("CGS Account")} field={'CGSAccount'} options={accounts} />
                                </div>
                                <div className="col-12 mb-3 px-0">
                                    <AccountSelect label={t("Wastages Account")} field={'WastagesAccount'} options={accounts} />
                                </div>
                            </div>
                        </Collapse>


                    </Row>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={HandleSubmit}><Trans>Save</Trans></Button>
            </ModalFooter>
        </Modal>
    )
}

export default SettingsModal

